import { Weblinkint as TWeblinkint } from '@/kontent/content-types'
import CustomModal from '@/legacy-ported/components/base/CustomModal'
import getUrlFromMapping from '@/utils/getUrlFromMapping'
import Link from 'next/link'
import { useState } from 'react'
import { RichtextSectionProps } from '.'
import {
	getLinkedItems,
	useKontentHomeConfig,
} from '../contexts/KontentHomeConfigProvider'

const WebLinkInternal = ({
	mappings,
	linkedItem,
}: RichtextSectionProps<TWeblinkint>) => {
	const { pageResponseLinkedItems, isInIframe } = useKontentHomeConfig()
	const [showPopup, setShowPopup] = useState(false)
	const itemCodename = getLinkedItems(
		linkedItem.elements.item,
		pageResponseLinkedItems,
	)?.[0]?.system?.codename

	const url = getUrlFromMapping(mappings, itemCodename)
	if (!url) {
		return <span>{linkedItem.elements.title.value}</span>
	}

	if (!isInIframe) {
		return (
			<>
				<Link
					href={url}
					target="_blank"
					onClick={() => {
						setShowPopup(true)
					}}
				>
					{linkedItem.elements.title.value}
				</Link>
				<CustomModal
					title="Information"
					modalStatus={showPopup}
					handleCancel={() => setShowPopup(false)}
					hideConfirmButton
				>
					<p>
						This content cannot be displayed in View side-by-side.
						Click the button below to open this link in a new tab or
						cancel to stay on this page
					</p>
				</CustomModal>
			</>
		)
	}

	return (
		<Link href={url}>
			<a>{linkedItem.elements.title.value}</a>
		</Link>
	)
}

export default WebLinkInternal
